module.exports = __webpack_public_path__ + "img/instagram-post.49ce91b9.svg";